import Generator from '../../Generator'
import Types from '../../../actions/Types'

export default Generator.node({
  baseType: Types.PRINT.FULL_INVENTORY,
  nodeType: Generator.NODETYPE.PRINT
})



// WEBPACK FOOTER //
// ./src/reducers/root/print/full_inventory.js